<template>
    <div>
        <div class="container">
            <div class="handle-box-search">

                <el-row class="head-search">

                </el-row>

                <!-- <el-button type="primary" icon="el-icon-search" @click="confListsSearch">搜索</el-button> -->

                <el-button @click="synchronization">同步</el-button>

                <el-button
                        icon="el-icon-refresh-right"
                        @click="refresh"
                >刷新
                </el-button>

            </div>

            <el-card class="box-card">


                <div style="display: flex;flex-wrap: wrap;">
<!--activeUsers-->
                    <div
                            style="width: 23%; margin: 0 1% 20px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1); border-radius: 10px;padding: 15px 0;"


                            v-for="(item2, index) in conf_data"
                    >

                        <div style="text-align: center;">

                            <p style="margin-top: 20px;">
                                {{ item2.name }}

                                <el-popover
                                        placement="top"
                                        trigger="hover"
                                        :content="item2.description"
                                >
                                    <i
                                            class="el-icon-question"
                                            slot="reference"
                                            style="color: #999;cursor: pointer;"
                                    ></i>
                                </el-popover>

                            </p>

                            <p style="font-size: 30px;height: 90px;line-height: 90px;font-weight: bold;color: #666;">
                                {{ item2.conf_value }}</p>
                            <el-button
                                    type="text"
                                    style="padding: 6px 10px;margin: 10px 0;color: #ccc;"
                                    @click="editRoleSubmitShow = !editRoleSubmitShow; editRole_data = item2"
                            >编辑 >
                            </el-button>

                        </div>

                    </div>

                </div>

            </el-card>

        </div>

        <!-- 编辑的弹窗子组件 -->
        <editConfSubmit
                :isShow="editRoleSubmitShow"
                :editRole_data="editRole_data"
                @submit_ok_return="confLists"
        >
        </editConfSubmit>

    </div>
</template>
<script>
    var _this;

    import editConfSubmit from '../conf/editConfSubmit';

    export default {
        components: {
            editConfSubmit
        },


        computed: {
            activeUsers: function() {
                return this.conf_data.filter(function(user) {
                    return user.is_show == 1;
                });
            }
        },

        data() {
            return {
                city_name: '',

                conf_data: [],

                // 初始化页面时传入的参数
                search_data: {},

                //编辑的抽屉
                editRoleSubmitShow: false,

                // 点击编辑的时候传给子组件的值
                editRole_data: ''
            };
        },

        //生命周期，建立
        created() {
            _this = this;

            //初始化显示列表

            _this.confLists();
        },
        methods: {
            // 同步
            synchronization() {
                _this
                    .$post('/conf/confInitialization')
                    .then((res) => {
                        _this.$message.success('同步成功');
                        _this.confLists();
                    })
                    .catch((err) => {
                    });
            },

            //搜索角色列表(初始化列表)
            confLists() {
                _this
                    .$post('/conf/confLists', _this.search_data)
                    .then((res) => {
                        _this.conf_data = res.data;

                        _this.city_name = res.data[0].city.name;

                        _this.result_data = res;
                    })
                    .catch((err) => {
                    });
            },

            //刷新页面
            refresh() {
                this.$router.go(0);
            }
        }
    };
</script>

<style scoped>
    .checkbox {
        position: absolute;
        margin-left: 21px;
        top: 20px;
    }

    .page {
        position: absolute;
        right: 0;
    }

    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .box-card {
        margin-bottom: 20px;
    }
</style>
